module.exports = __webpack_public_path__ + "media/assets/images/flags/vg-41c9a36d074e2db9e2584ea7dfa16821.svg";